import { render } from "./product-single.vue?vue&type=template&id=3f35eb1b&scoped=true"
import script from "./product-single.vue?vue&type=script&lang=js"
export * from "./product-single.vue?vue&type=script&lang=js"

import "./product-single.vue?vue&type=style&index=0&id=3f35eb1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f35eb1b"]])

export default __exports__